export default "__VITE_ASSET__dqwT64N7__"